import './styles.scss';

import { ReactElement, useEffect, useState } from 'react';

import CategoryRow from './CategoryRow';
import EvaluationPreviewModal from '@/pages/Users/components/EvaluationPreviewModal';
import Table from '@/common/Table';
import { TrainingChecklistTableTypes } from './types';
import useTrainingChecklistTableState from './hook';

export type TrainingChecklistTableProps = {
  userId: string;
  driverFirstName?: string;
  driverLastName?: string;
};

const Header = (): ReactElement => (
  <Table.Row header>
    <Table.Cell className="CATEGORY">Training Category</Table.Cell>
    <Table.Cell className="STATUS">Status</Table.Cell>
    <Table.Cell className="TRAINER">Trainer</Table.Cell>
    <Table.Cell className="ACTION">Training Checklist</Table.Cell>
  </Table.Row>
);

const TrainingChecklistTable = ({ userId, driverFirstName, driverLastName }: TrainingChecklistTableProps): ReactElement => {
  const [{ rows, load, evaluate }] = useTrainingChecklistTableState(({ state }) => [
    {
      rows: state.rows,
      load: state.load,
      evaluate: state.evaluate,
    },
  ]);
  const [previewCategory, setPreviewCategory] = useState<TrainingChecklistTableTypes.ChecklistItem | null>(null);

  useEffect((): void => {
    load(userId);
  }, [userId, load]);

  return (
    <>
      <Table className="TrainingChecklistTable" header={<Header />}>
        {!rows.length && (
          <Table.Row virtualize={false} className="justify-content-center">
            <Table.Cell className="text-center">
              <span>No training to complete.</span>
            </Table.Cell>
          </Table.Row>
        )}
        {rows.map(
          (row): ReactElement => (
            <CategoryRow
              key={row.id}
              data={row}
              onDoubleClick={setPreviewCategory}
              onEvaluate={async (): Promise<void> => {
                await evaluate(userId);
                setPreviewCategory(row);
              }}
            />
          )
        )}
      </Table>
      <EvaluationPreviewModal
        categoryId={previewCategory?.id ?? null}
        categoryName={previewCategory?.name}
        driverFirstName={driverFirstName}
        driverLastName={driverLastName}
        onHide={(): void => setPreviewCategory(null)}
      />
    </>
  );
};

export default TrainingChecklistTable;
